import styled from "styled-components"

export const DeprecatedMenu = styled.nav<{
  mode: "light" | "dark"
}>`
  width: 15rem;
  height: 100%;
  padding: 0.5rem;
  flex-direction: column;
  display: flex;
  min-height: 100vh;
  background-color: ${({ theme, mode }) => (mode === "light" ? theme.colors.black.$100 : theme.colors.black.$1000)};
`
